import { MutationTree } from 'vuex';
import { ErrorDetail } from '../../types';
import { NodeTypeState } from './types';
import * as types from './mutation-types';

export const mutations: MutationTree<NodeTypeState> = {
    // OS種別取得系
    [types.NORMAL_NODE_INDEX_START](state) {
        const indexState = state.normalNodeIndex;
        indexState.list = undefined;
        indexState.error = false;
        indexState.errorTitle = undefined;
        indexState.errorDetails = undefined;
        indexState.isProcessing = true;
    },

    [types.NORMAL_NODE_INDEX_SUCCESS](state, resData: any) {
        const indexState = state.normalNodeIndex;
        indexState.list = resData;
        indexState.isProcessing = false;
    },

    [types.NORMAL_NODE_INDEX_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const indexState = state.normalNodeIndex;
        indexState.errorTitle = payload.errorTitle;
        indexState.errorDetails = payload.errorDetails;
        indexState.error = true;
        indexState.isProcessing = false;
    },

    [types.SIMPLE_NODE_INDEX_START](state) {
        const indexState = state.simpleNodeIndex;
        indexState.list = undefined;
        indexState.error = false;
        indexState.errorTitle = undefined;
        indexState.errorDetails = undefined;
        indexState.isProcessing = true;
    },

    [types.SIMPLE_NODE_INDEX_SUCCESS](state, resData: any) {
        const indexState = state.simpleNodeIndex;
        indexState.list = resData;
        indexState.isProcessing = false;
    },

    [types.SIMPLE_NODE_INDEX_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const indexState = state.simpleNodeIndex;
        indexState.errorTitle = payload.errorTitle;
        indexState.errorDetails = payload.errorDetails;
        indexState.error = true;
        indexState.isProcessing = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const normalNodeIndexState = state.normalNodeIndex;
        normalNodeIndexState.isProcessing = false;

        const simpleNodeIndexState = state.simpleNodeIndex;
        simpleNodeIndexState.isProcessing = false;
    },
};
